import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import _ from "lodash";
import TimeStamp from "react-timestamp";
import withAuthorization from "../../components/Authorization/withAuthorization";
import {
  Grid,
  Row,
  Col,
  FormControl,
  Popover,
  OverlayTrigger,
} from "react-bootstrap";
import MyMap from "./MyMap";
import mapStyle from "./MapStyle";
import MapSlider from "./MapSlider";
import { Slider, Handles, Tracks, Rail, Ticks } from "react-compound-slider";
import "../../assets/css/mapview.css";
import "../../assets/css/header.css";

import LocalizedStrings from "react-localization";
import GoogleMapReact from "google-map-react";
let localizationStrings = new LocalizedStrings({
  en: {
    auditTrailTitle: "Audit Trail List (with map)",
    selectTitle: "- Please Select Your lock Type -",
  },
  ja: {
    auditTrailTitle: "監査証跡リスト (地図付き)",
    selectTitle: "ロックを選択してください",
  },
  es: {
    auditTrailTitle: "Lista de Registro de Auditoría (con mapa)",
    selectTitle: "- Por favor seleccione su tipo de candado -",
  },
});

class MapAudit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myadminlocklistArray: [],
      ATArray: [],
      selectedLock: "",
      selectedLockSerial: "",
      loading: true,
      numberOfAuditTrailEntries: 0,
      minTimeVal: 0.0,
      maxTimeVal: 0.0,
    };
    // }
    this.detectOnChangeEvent = this.detectOnChangeEvent.bind(this);
    // this.renderMapMarkers = this.renderMapMarkers.bind(this);
    this.auditTrailMainCardComponent = this.auditTrailMainCardComponent.bind(
      this
    );
    this.auditTrailLockUnlockSubComponent = this.auditTrailLockUnlockSubComponent.bind(
      this
    );
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
    this.sliderSection = this.sliderSection.bind(this);
    this.setSliderUpdatedState = this.setSliderUpdatedState.bind(this);
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };

  // componentDidMount() {
  //   if ("geolocation" in navigator) {
  //     console.log("Available");
  //     navigator.geolocation.getCurrentPosition(function (position) {
  //       console.log("Latitude is :", position.coords.latitude);
  //       console.log("Longitude is :", position.coords.longitude);
  //     });
  //   } else {
  //     console.log("Not Available");
  //   }
  // }

  componentWillMount() {
    fire
      .database()
      .ref("MyAdminLocks")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        this.setState({
          myadminlocklistArray: snapshot.val(),
          loading: false,
        });
        // console.log(snapshot.val());
      });
  }

  fetchSelectedLockFromAuditLocksList(selectedLockSerial) {
    fire
      .database()
      .ref("AuditTrail")
      .child(selectedLockSerial)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot);
        if (tempArray.length > 0) {
          tempArray.reverse();
          var minTime = tempArray[tempArray.length - 1].time;
          var maxTime = tempArray[0].time;
        } else {
          var minTime = 0.0;
          var maxTime = 0.0;
        }

        this.setState({
          ATArray: tempArray,
          loading: false,
          numberOfAuditTrailEntries: tempArray.length,
          minTimeVal: minTime,
          maxTimeVal: maxTime,
        });
        // console.log(tempArray);
      });
  }

  forceUpdateHandler() {
    this.forceUpdate();
  }

  auditTrailLockUnlockSubComponent(text) {
    if (text === "UNLOCKED") {
      return (
        <p
          style={{
            color: "red",
            fontWeight: "bold",
            textAlign: "center",
            fontSize: "1.5em",
          }}
        >
          {text}
        </p>
      );
    } else {
      return (
        <p
          style={{
            color: "green",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "1.5em",
          }}
        >
          {text}
        </p>
      );
    }
  }

  auditTrailMainCardComponent() {
    return _.map(this.state.ATArray, (index) => {
      return (
        <div className={"AuditTrailDiv"}>
          {this.auditTrailLockUnlockSubComponent(index.lockedStatus)}
          <TimeStamp time={index.time / 1000} format="full" includeDay />
          <p style={{ fontWeight: "light", fontSize: "0.8em" }}>
            {index.userEmail}
          </p>
          <p style={{ fontWeight: "light", fontSize: "0.8em" }}>
            {index.Placemark}
          </p>
          <hr />
          {/* Look up the user's name? */}
        </div>
      );
    });
  }

  renderDropdown() {
    return _.map(this.state.myadminlocklistArray, (lockData) => {
      return <option>{lockData.ip45SerialNumber}</option>;
    });
  }

  detectOnChangeEvent(event) {
    var val = event.target.value;
    this.setState({
      selectedLock: val,
      count: 0,
    });
    var selectedLock = event.target.value;
    this.fetchSelectedLockFromAuditLocksList(selectedLock);
  }

  setSliderUpdatedState = (array) => {
    this.setState({ ATArray: array });
  };

  mapViewSection() {
    const mapOptions = {
      styles: mapStyle,
    };
    if (this.state.ATArray < 1) {
      return (
        <div style={{ height: "75vh", width: "75%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API_KEY }}
            defaultCenter={{ lat: 1.275821903978486, lng: 103.79596010423822 }}
            defaultZoom={1}
            // options={mapOptions}
          ></GoogleMapReact>
        </div>
      );
    } else {
      return <MyMap incomingLogs={this.state.ATArray} />;
    }
  }

  sliderSection() {
    if (this.state.ATArray.length > 0) {
      return (
        <div>
          <label style={{ marginBottom: "20px" }}>Sort By Date: </label>
          <MapSlider
            minVal={this.state.minTimeVal}
            maxVal={this.state.maxTimeVal}
            selectedLock={this.state.selectedLock}
            setArray={this.setSliderUpdatedState}
          />
        </div>
      );
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    return (
      <div
        style={{
          maxWidth: "95%",
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: "20px",
        }}
      >
        <div className="header">
          <h2>{localizationStrings.auditTrailTitle}</h2>
          {this.sliderSection()}
          <div
            id="mapViewDropDownContainer"
            style={{
              display: "flex",
              backgroundColor: "white",
              maxHeight: "120vh",
            }}
          >
            <div
              id="dropDownContainerMapView"
              style={{ width: "30%", height: "75vh", overflow: "scroll" }}
            >
              <div>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  onChange={this.detectOnChangeEvent}
                >
                  <option value="null">Please Select a Lock</option>
                  {this.renderDropdown()}
                </FormControl>
              </div>

              {this.auditTrailMainCardComponent()}
            </div>

            {/* {<MyMap incomingLogs={this.state.ATArray} />} */}
            {this.mapViewSection()}
          </div>
        </div>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(MapAudit);
